import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import paperplane from 'src/assets/lottie/paperplane.lottie'
import { useDispatch, useSelector } from 'react-redux';
import { submitProcesarPago } from 'src/reducer/action/pago';
import { getTotalPagar } from 'src/helpers/pagoFedpa';

export const Clave = ({
  step,
  stepForward
}) => {
  const dispatch = useDispatch()
  const { polizas: polizasPagar } = useSelector(state => state.pago.pagar)
  const {
    loadingResponse,
    formaPago,
    email
  } = useSelector(state => state.pago)

  const { status, processUrl } = useSelector(state => state.pago.clave)

  useEffect(() => {
    dispatch(
      submitProcesarPago({
        idorigen: formaPago,
        email: email,
        pagos: polizasPagar,
        clave: {
          redirectUrl: window.location.href,
          amount: getTotalPagar(polizasPagar) || 0,
        }
      }, { step, stepForward }));


  }, [dispatch])


  return (
    <div>
      <br />
      <br />
      <Row className="justify-content-center">
        <Col md={5} className="text-center">
          <DotLottieReact
            src={paperplane}
            autoplay
            loop
            className="w-48 h-48"
          />

          <h5 className="fw-bold mb-3">
            Preparando tu pago
          </h5>

          <p className="text-muted">
            En unos instantes serás redirigido a la plataforma de Clave de Telered,
            donde podrás completar tu transacción de forma segura.
          </p>
        </Col>
      </Row>
    </div>
  )
}
